import React from 'react';
import { QuestMarker } from '../../icons';

/**
 * Single available mission.
 */
const AvailableMissionItem = ({ task, onGoToTask, onMouseEnter, onMouseLeave }) => (
  <div
    className="flowchart-hud__mission-item"
    onClick={() => onGoToTask?.(task.id)}
    onMouseEnter={onMouseEnter}
    onMouseLeave={onMouseLeave}
  >
    <span className="flowchart-hud__mission-marker">
      <QuestMarker size={16} className="flowchart-hud__quest-icon--small" />
    </span>
    <span className="flowchart-hud__mission-name">
      {task.name}
    </span>
  </div>
);

export default AvailableMissionItem;
